import { ENV } from "../Utils";

export class QuizApi {
  baseApi = ENV.BASE_API;

  // GET: Obtener todos los quizz asociados a un teacher (se pasa teacherId en la URL)
  async getAllQuizzes(accessToken, teacherId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.QUIZZES}/getall/${teacherId}`;
      const params = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
  async setActiveTeacherQuiz(accessToken, teacherId, quizId) {
    const url = `${this.baseApi}/${ENV.API_ROUTES.QUIZZES}/activeTeacher/${teacherId}`;
    const params = {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      // si quizId es falsy (null/undefined), body será {} y lo desasigna
      body: JSON.stringify(quizId ? { quizId } : {}),
    };
    const response = await fetch(url, params);
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
  // GET: Obtener un quizz por su ID
  async getQuizById(accessToken, quizId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.QUIZZES}/get/${quizId}`;
      const params = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  // POST: Crear un nuevo quizz (requiere teacherId en la URL)
  async createQuiz(accessToken, teacherId, data) {
    try {
      // data es un objeto que debe incluir: name, description y questions (array)
      const url = `${this.baseApi}/${ENV.API_ROUTES.QUIZZES}/create/${teacherId}`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 201) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  // PATCH: Actualizar un quizz existente
  async updateQuiz(accessToken, quizId, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.QUIZZES}/update/${quizId}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  // DELETE: Eliminar un quizz
  async deleteQuiz(accessToken, quizId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.QUIZZES}/delete/${quizId}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  // PATCH: Activar un quizz en una ruta didáctica (asocia el quizz a la ruta)
  async activateQuiz(accessToken, routeId, quizId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.QUIZZES}/active/${routeId}/${quizId}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  // GET: Obtener los resultados (intentos de alumnos) de un quizz
  async getQuizResults(accessToken, quizId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.QUIZZES}/results/${quizId}`;
      const params = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  // GET: Obtener ranking de un quizz para un teacher y classnumber
  async getRankingResults(accessToken, teacherId, quizId, classnumber) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.QUIZZES}/ranking/${teacherId}/${quizId}/${classnumber}`;
      const params = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  // POST: Registrar el intento de quizz realizado por un alumno
  async submitStudentQuiz(accessToken, studentId, data) {
    try {
      // data debe incluir: teacherQuizId, responses (array), timeTaken, y totalTime (opcional)
      const url = `${this.baseApi}/${ENV.API_ROUTES.QUIZZES}/student/${studentId}`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  // GET: Obtener resultado detallado del quizz para un alumno
  async getDetailedStudentResult(accessToken, studentId, quizId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.QUIZZES}/studentresult/${studentId}/${quizId}`;
      const params = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}
